"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunaHyperloopCorporation = void 0;
const CardName_1 = require("../../CardName");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const Resources_1 = require("../../Resources");
const TileType_1 = require("../../TileType");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Tags_1 = require("../Tags");
class LunaHyperloopCorporation extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.LUNA_HYPERLOOP_CORPORATION,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.BUILDING],
            startingMegaCredits: 38,
            metadata: {
                description: 'You start with 38 M€ and 4 steel.',
                cardNumber: 'MC4',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.megacredits(38).steel(4);
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action('Gain 1 M€ for each road tile on the Moon.', (eb) => {
                            eb.empty().startAction.megacredits(1).slash().nbsp().moonRoad({ size: Size_1.Size.SMALL }).any;
                        });
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.vSpace(Size_1.Size.LARGE);
                    });
                    b.vpText('1 VP for each road tile on the Moon.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.moonRoadTile(1, true),
            },
        });
    }
    play(player) {
        player.steel += 4;
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const roadTileCount = MoonExpansion_1.MoonExpansion.tiles(player.game, TileType_1.TileType.MOON_ROAD, { surfaceOnly: true }).length;
        player.addResource(Resources_1.Resources.MEGACREDITS, roadTileCount, { log: true });
        return undefined;
    }
    getVictoryPoints(player) {
        return MoonExpansion_1.MoonExpansion.tiles(player.game, TileType_1.TileType.MOON_ROAD, { surfaceOnly: true }).length;
    }
}
exports.LunaHyperloopCorporation = LunaHyperloopCorporation;
//# sourceMappingURL=LunaHyperloopCorporation.js.map